import dayjs from 'dayjs';

export const formatDate = (timeInMillisecond?: number): string => (timeInMillisecond ? dayjs(new Date(timeInMillisecond)).format('MMMM D, YYYY') : '');
